import React from "react";

const SearchInput = ({handleSearch}) => {
    return (
        <div className="w-full flex flex-col items-start gap-3">
            <label htmlFor="search" className="text-lg text-gray-800 font-semibold">
                Search
            </label>
            <input
                id="search"
                type="search"
                onChange={handleSearch}
                className="border mb-4 border-gray-300 rounded-lg py-3 px-4 w-full md:w-1/2 max-w-lg text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200 ease-in-out"
                placeholder="Search here..."
            />
        </div>
    )
}

export default SearchInput